var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// eslint-disable-next-line import/no-extraneous-dependencies
import packageJson from 'tv/package.json';
import { v4 as uuid } from 'uuid';
import { CACHE_KEY } from '../../../constants/commonConstants';
import TvingLogModule from '../../tving-log-module/TvingLogModule';
import { DeviceModelName, PlatformName } from '../types';
import 'webostvjs';
var WebOSDeviceManager = /** @class */ (function () {
    function WebOSDeviceManager() {
        this.logger = TvingLogModule;
        this.webOsDeviceInfo = {};
        this.webOsDeviceInfo.platformId = PlatformName.webos;
        this.webOsDeviceInfo.modelName = DeviceModelName.webos;
        this.webOsDeviceInfo.screenWidth = 0;
        this.webOsDeviceInfo.screenHeight = 0;
    }
    WebOSDeviceManager.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var deviceUuid, resolutionWidth, resolutionHeight, deviceModel, osVersion;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.logger.info('[WebOSDeviceManager.init()]');
                        deviceUuid = localStorage.getItem(CACHE_KEY.uuid);
                        if (deviceUuid) {
                            this.webOsDeviceInfo.uuid = deviceUuid;
                        }
                        else {
                            this.webOsDeviceInfo.uuid = uuid();
                            localStorage.setItem(CACHE_KEY.uuid, this.webOsDeviceInfo.uuid);
                        }
                        // APP VERSION
                        return [4 /*yield*/, new Promise(function (resolve) {
                                window.webOS.fetchAppInfo(function (appInfo) {
                                    if (!appInfo) {
                                        _this.logger.error('[WebOSDeviceManager.init()] appInfo is null');
                                        _this.webOsDeviceInfo.appVersion = '4.0.0';
                                        resolve();
                                    }
                                    else {
                                        _this.webOsDeviceInfo.appVersion = appInfo.version;
                                        resolve();
                                    }
                                });
                            })];
                    case 1:
                        // APP VERSION
                        _a.sent();
                        resolutionWidth = localStorage.getItem(CACHE_KEY.DEVICE_RESOLUTION_WIDTH);
                        resolutionHeight = localStorage.getItem(CACHE_KEY.DEVICE_RESOLUTION_HEIGHT);
                        deviceModel = localStorage.getItem(CACHE_KEY.DEVICE_MODEL);
                        osVersion = localStorage.getItem(CACHE_KEY.DEVICE_OS_VERSION);
                        if (!(resolutionWidth && resolutionHeight && deviceModel && osVersion)) return [3 /*break*/, 2];
                        this.webOsDeviceInfo.screenWidth = Number(resolutionWidth);
                        this.webOsDeviceInfo.screenHeight = Number(resolutionHeight);
                        this.webOsDeviceInfo.modelName = deviceModel;
                        this.webOsDeviceInfo.osVersion = osVersion;
                        return [3 /*break*/, 4];
                    case 2: 
                    // TODO: timeout by [Promise.race]
                    return [4 /*yield*/, new Promise(function (resolve) {
                            window.webOS.deviceInfo(function (device) {
                                var sdkVersion = device.sdkVersion, modelName = device.modelName, screenWidth = device.screenWidth, screenHeight = device.screenHeight;
                                _this.webOsDeviceInfo.osVersion = sdkVersion;
                                localStorage.setItem(CACHE_KEY.DEVICE_OS_VERSION, _this.webOsDeviceInfo.osVersion);
                                if (modelName) {
                                    _this.webOsDeviceInfo.modelName = modelName.slice(0, 20);
                                    localStorage.setItem(CACHE_KEY.DEVICE_MODEL, _this.webOsDeviceInfo.modelName);
                                }
                                _this.webOsDeviceInfo.screenWidth = screenWidth;
                                _this.webOsDeviceInfo.screenHeight = screenHeight;
                                localStorage.setItem(CACHE_KEY.DEVICE_RESOLUTION_WIDTH, _this.webOsDeviceInfo.screenWidth.toString());
                                localStorage.setItem(CACHE_KEY.DEVICE_RESOLUTION_HEIGHT, _this.webOsDeviceInfo.screenHeight.toString());
                                resolve();
                            });
                        })];
                    case 3:
                        // TODO: timeout by [Promise.race]
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // deeplink(callback: (mediaCode: string) => void): void {
    WebOSDeviceManager.prototype.deeplink = function () {
        this.logger.info('[WebOSDeviceManager.deeplink()]');
    };
    WebOSDeviceManager.prototype.twoDepth = function (profileToken) {
        var _this = this;
        var params = {
            method: profileToken ? 'setPersonalKey' : 'clearPersonalKey',
            parameters: profileToken
                ? {
                    appId: 'cj.eandm',
                    key: profileToken,
                    expiredTime: Math.floor(Date.now() / 1000) + 60 * 60 * 24 * 30,
                }
                : { appId: 'cj.eandm' },
            onSuccess: function (response) {
                _this.logger.debug('set home preview success', response);
            },
            onFailure: function (error) {
                _this.logger.debug('set home preview fail', error);
            },
        };
        window.webOS.service.request('luna://com.webos.service.contentminer', params);
    };
    WebOSDeviceManager.prototype.exit = function () {
        this.logger.info('[WebOSDeviceManager.exit()]');
        window.close();
    };
    WebOSDeviceManager.prototype.getDeviceInfo = function () {
        this.logger.info('[WebOSDeviceManager.getDeviceInfo()]');
        var _a = this.webOsDeviceInfo, appVersion = _a.appVersion, screenHeight = _a.screenHeight, screenWidth = _a.screenWidth, modelName = _a.modelName, platformId = _a.platformId, uuid = _a.uuid, osVersion = _a.osVersion;
        return {
            platformOs: "".concat(platformId, " ").concat(osVersion),
            appVersion: appVersion,
            appWebVersion: "".concat(appVersion || '4.0.0', "_").concat(packageJson.version),
            deviceModel: modelName,
            resolutionWidth: screenWidth,
            resolutionHeight: screenHeight,
            osVersion: osVersion,
            uuid: uuid,
        };
    };
    return WebOSDeviceManager;
}());
export default WebOSDeviceManager;
